//libs
import React from 'react';

//components
import { Box, Stack, Typography } from '@lyearn/ui';
import { HeaderProps } from '@/components/Modals/types';

//types

export const modalHeaderRenderer = (props?: HeaderProps): React.ReactNode => {
  const { Icon, title, description, children } = props ?? {};

  return (
    <Stack className="flex w-full flex-1" direction="col">
      <Stack className="flex-row items-center justify-start px-24 pt-24 pb-20">
        {Icon ? <Icon className="h-40 w-40 flex-shrink-0 me-20" /> : null}
        <Box className="flex-1 flex-col justify-start">
          <Typography variant="display-m">{title}</Typography>
          <Typography className="text-text-primary" variant="body-long-01">
            {description}
          </Typography>
        </Box>
      </Stack>
      <Stack className="w-full px-20" direction="col">
        {children}
      </Stack>
    </Stack>
  );
};

export const retryModalHeaderRenderer = (props?: HeaderProps): React.ReactNode => {
  const { title, description, children } = props ?? {};

  return (
    <Stack className="flex w-full flex-1" direction="col">
      <Stack className="flex-row items-center justify-start px-24 pt-24">
        <Box className="flex-1 flex-col justify-start">
          <Typography color="text-text-primary" variant="display-m">
            {title}
          </Typography>
          <Typography className="mt-8" color="text-text-paragraph" variant="body-long-01">
            {description}
          </Typography>
        </Box>
      </Stack>
      <Stack className="w-full px-20" direction="col">
        {children}
      </Stack>
    </Stack>
  );
};
